const PDF_MAGIC = [0x25, 0x50, 0x44, 0x46, 0x2d]; // "%PDF-"
const ZIP_MAGIC = [0x50, 0x4b, 0x03, 0x04]; // .xlsx / .xlsb are zip containers
const OLE_MAGIC = [0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1]; // legacy .xls
/** How many leading bytes {@link detectFileKind} needs. */
export const FILE_KIND_HEAD_BYTES = 1024;
const startsWith = (head, magic, at = 0) => magic.every((b, i) => head[at + i] === b);
export function detectFileKind(head) {
    // The PDF spec allows junk before the header, within the first 1024 bytes.
    const limit = Math.min(head.length, FILE_KIND_HEAD_BYTES) - PDF_MAGIC.length;
    for (let i = 0; i <= limit; i++)
        if (startsWith(head, PDF_MAGIC, i))
            return 'pdf';
    if (startsWith(head, ZIP_MAGIC) || startsWith(head, OLE_MAGIC))
        return 'excel';
    return 'other';
}
//# sourceMappingURL=fileKind.js.map